import React from 'react';
import './CSS/Footer.css';

function Footer() {
  return (
    <div className="footer">
      <div className="copyright">
        <h4>Designed by Kidist-Guta</h4>
        <p>Copyright@2022</p>
      </div>
    </div>
  );
}

export default Footer;
